import { StyleSheet } from 'aphrodite';
import { background, inputBorderColor, navigation } from '../../styles/colors';

export const s = StyleSheet.create({
	textArea: {
		display: `flex`,
		minHeight: 60,
		width: `100%`,
		borderRadius: 6,
		border: `1px solid ${inputBorderColor}`,
		boxSizing: `border-box`,
		resize: `none`,
		padding: `8px 12px`,
		fontSize: `14px`,
		backgroundColor: background,
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
		'::placeholder': {
			color: navigation,
		},
		':focus': {
			outline: `none`,
		},
	},
});
